<template>
  <div class="container">
    <CRow alignHorizontal="end" alignVertical="center">
      <div class="containerIconClose" @click="linkTo(cardContent)">
        <font-awesome-icon icon="times" class="IconClose" />
      </div>
    </CRow>
    <CCard class="customCard">
      <CCardHeader class="customCardHeaderActive">
        <CRow
          alignHorizontal="between"
          alignVertical="center"
          class="mr-2 ml-2"
        >
          <h3
            :class="checkLangClass() + ' ' + 'm-2 text_header'"
            v-c-tooltip="{
              content:
                checkLanguage(cardContent.title) +
                checkLanguage(cardContent.description),
              placement: 'bottom',
            }"
          >
            {{ checkLanguage(cardContent.title) }} :
            {{ checkLanguage(cardContent.description) }}
          </h3>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow class="m-1" align-horizontal="center" align-vertical="center">
          <CCol xl="6" lg="6" md="6" sm="6">
            <template v-if="typeInfo == 'Initials'">
              <CRow
                class="pa-0"
                alignHorizontal="center"
                alignVertical="center"
              >
                <template v-if="info == 'Initials'">
                  <div
                    :class="checkLangClass()"
                    style="font-size: 2rem; font-weight: bold"
                  >
                    {{ checkLanguage(cardContent.content.question[0].title) }}
                  </div>
                </template>
                <template v-else-if="info == 'Tones'">
                  <div
                    :class="checkLangClass() + ' ' + 'fontPinyin'"
                    :style="
                      lang == 'TH'
                        ? 'font-size: 40px; font-weight: bold;'
                        : 'font-size: 50px; font-weight: bold;'
                    "
                  >
                    {{ checkLanguage(cardContent.content.question[0].title) }}
                  </div>
                </template>
                <template v-else>
                  <div
                    :class="checkLangClass() + ' ' + 'fontPinyin'"
                    style="font-size: 50px; font-weight: bold"
                  >
                    {{ info }}
                  </div>
                </template>
                <!-- Initials text -->
              </CRow>
            </template>
            <template v-else-if="typeInfo == 'audio'">
              <CRow alignHorizontal="center" alignVertical="center">
                <div
                  class="containerIconAudio"
                  @click="
                    playSound(
                      baseUrl +
                        cardContent.content.question[0].choices[0].choice
                          .choices.item.data
                    )
                  "
                >
                  <font-awesome-icon icon="volume-up" class="IconClose" />
                </div>
              </CRow>
            </template>
          </CCol>
          <CCol
            xl="6"
            lg="6"
            md="6"
            sm="6"
            xs="4"
            style="display: flex; justify-content: center"
          >
            <CRow
              class="img-container p-2"
              alignHorizontal="left"
              alignVertical="center"
            >
              <template v-if="info == 'Initials'">
                <template v-for="item in choices">
                  <MartixChoice
                    :key="item.comment"
                    :item="item"
                    @parentOnClick="firstSelection"
                    :dataLength="dataLength"
                    :CheckWidth="CheckWidth"
                  />
                </template>
              </template>
              <template v-else-if="MatrixTones == 'Tones'">
                <template v-for="item in choices">
                  <MartixChoice
                    :key="item.comment"
                    :item="item"
                    @parentOnClick="thirdSelection"
                    :dataLength="dataLength"
                    :CheckWidth="CheckWidth"
                  />
                </template>
              </template>
              <template v-else-if="MatrixTones == 'VALUE'">
                <template v-for="(item, index) in choices">
                  <MartixChoiceValue
                    :key="index"
                    :count="index"
                    :item="item"
                    @parentOnClick="secondSelection"
                    :dataLength="dataLength2"
                    :CheckWidth="CheckWidth"
                  />
                </template>
              </template>
              <template v-else>
                <template v-for="(item, index) in choices">
                  <MartixChoice
                    :key="item.comment"
                    :item="item"
                    :count="index"
                    @parentOnClick="secondSelection"
                    :dataLength="dataLength"
                    :CheckWidth="CheckWidth"
                  />
                </template>
              </template>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import MartixChoice from './MartixChoice';
import MartixChoiceValue from './MartixChoiceValue';
import {mapGetters} from 'vuex';
export default {
  components: {MartixChoice, MartixChoiceValue},
  name: 'CardMatrix',
  props: {
    info: String,
    typeInfo: String,
    cardContent: Object,
    cardSetting: Object,
    MatrixTones: String,
    initialAnswer: Array,
    AnswerChoice: Array,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_URL_SOUND,
      current: '',
      answer: [],
      choices: [],
      dataLength: '',
      dataLength2: '',
      getIntitial: '',
      lang: '',
      CheckWidth: window.innerWidth,
      CheckAnswer: [],
      soundHolder: '',
      newSound: '',
      oldSound: '',
      answerCount: 0,
    };
  },

  computed: {
    ...mapGetters({
      getLanguage: 'language/getLanguage',
    }),
  },

  watch: {
    info(value) {
      if ('Initials' == value) {
        this.choices = this.cardContent.content.question[0].item;
        let selected = document.getElementsByClassName('matrix matrix-active');
        this.unActiveMatrix(selected[0]);
      }
      // else{
      //   this.typeInfo = value
      // }
    },
    cardContent: function () {
      this.dataLength = this.cardContent.content.question[0].item.length;
      this.choices = this.cardContent.content.question[0].item;
      this.dataLength2 = this.cardContent.content.question[0].choices.length;
    },
    getLanguage: function (val) {
      this.lang = val;
    },
  },

  mounted() {
    console.log(this.choices, 'choices');

    this.setDataLenght();
  },

  created() {
    this.lang = this.$store.state.language.language;
  },

  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinyin';
      } else {
        return '';
      }
    },
    linkTo(path) {
      //??
      let str = path.navigate.close.action.split('-');
      this.$router.push('/' + str[0] + '/' + str[1]);
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      }
    },
    test(sound, old) {
      if (old != '') {
        this.soundHolder = this.oldSound;
        old.pause();
        this.oldSound = '';
        if (this.oldSound == '') {
          this.playSound(sound);
        }
      } else {
        this.playSound(sound);
        this.oldSound = this.soundHolder;
      }
    },
    playSound(sound) {
      var a = new Audio(sound);
      a.play();
    },
    setDataLenght() {
      this.dataLength = this.cardContent.content.question[0].item.length;
      this.dataLength2 = this.cardContent.content.question[0].choices.length;
    },
    filterData(data, refCode) {
      let filter_data = data.filter((item) => {
        if (item.choice.choices.refCode == refCode) {
          return item;
        }
      });
      return filter_data;
    },
    firstSelection(id, data) {
      this.info = data;
      this.choices = [];
      let choices = this.filterData(
        this.cardContent.content.question[0].choices,
        id
      );
      this.choices = choices;

      // this.dataLength = choices.length;
      let lengthStr = choices.length;
      this.dataLength2 = lengthStr.toString();
      this.getIntitial = id;
    },
    thirdSelection(id, set) {
      let choices = this.filterData(
        this.cardContent.content.question[0].choices,
        id
      );

      var sound = choices[0].choice.choices.item.data;

      if (sound) {
        this.playSound(this.baseUrl + sound);
      }
      this.info = set;

      // this.info = this.cardContent.choices[id - 1].value;
      let selectedItem = document.getElementsByClassName(
        'matrix matrix-active'
      );
      if (1 > selectedItem.length) {
        this.activeMatrix(id);
      } else {
        this.unActiveMatrix(selectedItem[0]);
        this.activeMatrix(id);
      }
    },
    secondSelection(id, value) {
      this.dataLength = this.cardContent.content.question[0].item.length;
      if (this.cardContent.MatrixTones === 'Tones') {
        // this.info = this.cardContent.choices[id - 1].value;
      } else if (this.cardSetting.answerType === 'one') {
        let selectedItem = document.getElementsByClassName(
          'matrix matrix-active'
        );
        if (1 > selectedItem.length) {
          this.info = value;
          this.activeMatrix(id);
          this.$emit('setIsRightActive', true);
          this.$emit('setInfo', this.info);
          this.$emit('setIntial', 1);
          var sound = this.choices[id].choice.choices.item.data;
          if (sound) {
            this.newSound = this.baseUrl + sound;
            this.soundHolder = this.newSound;
            // let oldSound = this.soundHolder;
            // this.playSound(new Audio(newSound), new Audio(oldSound));
            this.test(this.newSound, new Audio(this.oldSound));
          }
        } else {
          this.info = value;
          this.unActiveMatrix(selectedItem[0]);
          this.activeMatrix(id);
          let sound = this.choices[id].choice.choices.item.data;

          if (sound) {
            this.newSound = this.baseUrl + sound;
            this.soundHolder = this.newSound;
            this.test(this.newSound, new Audio(this.oldSound));
            // this.playSound(this.newSound, new Audio(oldSound));
          }
        }
      } else if (this.cardSetting.answerType === 'multi') {
        var select = document.getElementById(id);
        let SelectChild = select.children[0];
        if (this.answer.length <= 1) {
          if (select.className !== 'matrix-active') {
            this.addTheAnswer(value, select, SelectChild);
            select.classList.remove('matrix');
            select.classList.add('matrix-active');
            this.$emit('setAnwser', this.initialAnswer);
          } else {
            select.classList.remove('matrix-active');
            select.classList.add('matrix');
            this.removeTheAnswer(value, select, SelectChild);
            this.$emit('setAnwser', this.initialAnswer);
          }
        } else {
          for (var item of this.answer) {
            var aaa = document.getElementById(item);
            aaa.classList.remove('matrix-active');
            aaa.classList.add('matrix');
            // this.answer = [];
          }
          // select.classList.remove("matrix");
          select.classList.add('matrix-active');
          this.answer = [];
          this.answer.push(id);
        }
      }
    },
    activeMatrix(id) {
      let item = document.getElementById(id);
      let itemChildren = item.children[0];
      if (item.className == 'matrix') {
        item.classList.add('matrix-active');
        itemChildren.classList.remove('checkDisplay');
      } else {
        item.classList.remove('matrix-active');
        itemChildren.classList.add('checkDisplay');
      }
    },
    unActiveMatrix(selectedItem) {
      let selectedItemChildren = selectedItem.children[0];
      selectedItem.classList.remove('matrix-active');
      selectedItemChildren.classList.add('checkDisplay');
    },
    addTheAnswer(value, selectedItem, selectedItemChild) {
      if (this.answerCount > 1) {
        this.clearTheAnswer(value);
      } else {
        this.initialAnswer.splice(this.answerCount, 1, value);
        this.answerCount = this.answerCount + 1;
      }
    },
    removeTheAnswer(value, selectedItem, selectedItemChild) {
      let ax = this.initialAnswer.indexOf(value);
      this.initialAnswer.splice(ax, 1, '');
      this.answerCount = this.answerCount - 1;
      // for (let item in this.initialAnswer) {
      //   this.initialAnswer.splice(item, 1, "");
      // }
      // for (let item in this.initialAnswer)
      //   if (this.initialAnswer[item] === value) {
      //     this.initialAnswer.splice(item, 1);
      //     this.initialAnswer.push("");
      //   }
    },
    clearTheAnswer(val) {
      this.answerCount = 1;
      let allSelected = document.getElementsByClassName('matrix');
      for (let item in this.initialAnswer) {
        this.initialAnswer.splice(item, 1, '');
        let selected = document.getElementsByClassName('matrix-active');
        for (let x of selected) {
          x.classList.add('matrix');
          x.classList.remove('matrix-active');
        }
      }
      for (var loops of this.answer) {
        let selected = document.getElementsByClassName('matrix-active');
        for (let x of selected) {
          x.classList.add('matrix');
          x.classList.remove('matrix-active');
        }
      }
      this.initialAnswer.splice(0, 1, val);
    },
  },
};
</script>

<style scoped>
.img-container {
  background-color: #f2f2f2 !important;
  width: 100%;
  height: 100%;
  font-size: 80px;
  border-radius: 20px;
}
.pa-0 {
  min-height: 200px;
}
@media screen and (max-width: 416px) {
  .pa-0 {
    min-height: 100px;
  }
  .img-container {
    width: auto;
  }
  .text_header {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
